/* La Nonna Tita - carrito instantáneo / reparación de drawer
   Corrige el caso donde el total se actualiza, pero los productos no aparecen hasta refrescar.
*/
(() => {
  if (window.LNTCartInstantLoaded) return;
  window.LNTCartInstantLoaded = true;

  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const routes = window.routes || {};
  const cartUrl = () => routes.cart_url || '/cart';
  const addUrl = () => routes.cart_add_url || '/cart/add';

  function isCartAddUrl(input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function setButtonState(button, text, disabled = true) {
    if (!button) return;
    if (!button.dataset.lntOriginalText) button.dataset.lntOriginalText = button.textContent.trim();
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    button.textContent = text;
  }

  function restoreButton(button, delay = 1200) {
    if (!button) return;
    setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      if (button.dataset.lntOriginalText) button.textContent = button.dataset.lntOriginalText;
    }, delay);
  }

  async function fetchCartSections() {
    const url = `${cartUrl()}?sections=${CART_SECTIONS.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('No se pudieron cargar las secciones del carrito');
    return response.json();
  }

  function htmlToDoc(html) {
    return new DOMParser().parseFromString(html || '', 'text/html');
  }

  function removeEmptyState() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
    drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    drawer.querySelector('.drawer__footer')?.removeAttribute('hidden');
  }

  function replaceCartIcon(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    const doc = htmlToDoc(sections['cart-icon-bubble']);
    const fresh = doc.querySelector('#cart-icon-bubble');
    const current = document.querySelector('#cart-icon-bubble');
    if (fresh && current) current.replaceWith(fresh);
  }

  function replaceDrawerCompletely(sections) {
    if (!sections || !sections['cart-drawer']) return false;

    const doc = htmlToDoc(sections['cart-drawer']);
    const freshDrawer = doc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (freshDrawer && currentDrawer) {
      currentDrawer.replaceWith(freshDrawer);
      freshDrawer.classList.remove('is-empty');
      freshDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
      freshDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      return true;
    }

    // Fallback para temas que entregan solo #CartDrawer dentro de la sección.
    const freshInner = doc.querySelector('#CartDrawer');
    const currentInner = document.querySelector('#CartDrawer');
    if (freshInner && currentInner) {
      currentInner.innerHTML = freshInner.innerHTML;
      removeEmptyState();
      return true;
    }

    return false;
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    removeEmptyState();
    setTimeout(() => {
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }, 60);
  }

  function publishCartUpdated(sections) {
    try {
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'lnt-cart-instant',
          cartData: { sections }
        });
      }
    } catch (e) {
      // El pub/sub no siempre existe en todos los contextos del tema.
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { sections } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections } }));
  }

  function renderCart(sections) {
    replaceCartIcon(sections);

    // Reemplazo completo: evita el bug donde queda cart-drawer.is-empty y solo se ve el total.
    const replaced = replaceDrawerCompletely(sections);
    if (!replaced) removeEmptyState();

    openDrawer();
    publishCartUpdated(sections);
  }

  async function refreshCartNow() {
    const sections = await fetchCartSections();
    renderCart(sections);
    return sections;
  }

  window.LNTRefreshCartNow = refreshCartNow;
  document.addEventListener('cart:refresh', () => refreshCartNow().catch(console.error));
  window.addEventListener('cart:refresh', () => refreshCartNow().catch(console.error));

  // Formularios personalizados de colección: agregar sin cambiar de página y refrescar drawer completo.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    // Si es product-form nativo, dejamos que Dawn/Crave lo maneje; el hook de fetch de abajo repara igual el drawer.
    if (form.closest('product-form')) return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"], button:not([type]), .button');
    setButtonState(button, 'Agregando...', true);

    try {
      const formData = new FormData(form);
      formData.append('sections', CART_SECTIONS.join(','));
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(addUrl(), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-LNT-Cart-Handled': 'true' },
        body: formData,
        credentials: 'same-origin'
      });

      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar al carrito');

      // Aunque Shopify devuelva sections, volvemos a pedir secciones limpias para evitar drawer incompleto.
      await refreshCartNow();
      setButtonState(button, '¡Agregado!', true);
      restoreButton(button);
    } catch (error) {
      console.error('LNT cart add error:', error);
      setButtonState(button, 'Error', true);
      restoreButton(button, 1800);
    }
  }, true);

  // Repara cualquier bloque que use fetch('/cart/add.js') sin refrescar bien los productos.
  const nativeFetch = window.fetch;
  window.fetch = async function(input, init = {}) {
    const response = await nativeFetch.apply(this, arguments);

    try {
      const headers = init && init.headers;
      const alreadyHandled = headers && (
        (headers instanceof Headers && headers.get('X-LNT-Cart-Handled')) ||
        (typeof headers === 'object' && headers['X-LNT-Cart-Handled'])
      );

      if (!alreadyHandled && isCartAddUrl(input) && response && response.ok) {
        setTimeout(() => refreshCartNow().catch(console.error), 120);
      }
    } catch (error) {
      console.warn('LNT cart fetch hook error:', error);
    }

    return response;
  };
})();
